import * as React from "react";
import { useState } from "react";
import { Button, Input, InputProps, Label, MessageBar, MessageBarTitle, MessageBarBody, MessageBarIntent } from "@fluentui/react-components";
import { login } from "../services/AuctionService";
import { useNavigate } from "react-router-dom";
import { IProfile } from "../models/profile";
export interface ILoginProps {
    setUser: (profile: IProfile) => void;
}

export const Login = (props: ILoginProps) => {
  const navigate = useNavigate();
  //const initialState = { user:'mcampulla@gmail.com', pwd:'Gennaio2026!' };
  const initialState = { user:'', pwd:'' };
  const [values, setValues] = useState(initialState);
  const [message, setMessage] = useState("");
  const { setUser } = props;

  const onChange: InputProps["onChange"] = (ev, data) => {
    setValues({ ...values, [ev.target.name]: ev.target.value });
  };

  const onLogin = async () => {
    console.log(values);
    setValues(initialState);
    const res = await login(values.user, values.pwd);   
    console.log(res);
    if(res.Success) {
      setUser({ userid: res.Result.userid, username: res.Result.username, displayname: res.Result.displayname, roles: res.Result.roles } ); 
      localStorage.setItem("token", JSON.stringify(res.Result.token));
      navigate('/');
    } else {
      setMessage(res.Message);
    }
  }
  
  return (
    <div className="container">
      <div className="page-title">LOGIN UTENTE</div>
      <div className="formDiv">
        <form>
          <div className="row mb-3">
            <div className="col-4"><Label required htmlFor={"user"}>Email</Label></div>
            <div className="col-8"><Input required type="text" name={"user"} value={values.user || ""} onChange={onChange} /></div>
          </div>
          <div className="row mb-3">
            <div className="col-4"><Label required htmlFor={"pwd"}>Password</Label></div>
            <div className="col-8"><Input required type="password" name={"pwd"} value={values.pwd || ""} onChange={onChange} /></div>
          </div>
          <div className="formButtonRow">
            <Button appearance="primary" size="medium" onClick={onLogin}>Accedi</Button>
          </div>
          {/* <div className="mt-3 mb-3">
            Hai dimenticato la password? <a href="/reset">Recupera password</a>
          </div> */}
          <div className="mt-3">
            Non hai un account? <a href="/register">Registrati</a>
          </div>
        </form>
      </div>
      <div className="formErrorDiv mt-3">
        {message && <MessageBar key="error" intent="error">
          <MessageBarBody>
            <MessageBarTitle>Errore:</MessageBarTitle>{message}
          </MessageBarBody>
        </MessageBar>}
      </div>
    </div>
  );
};